{
  "version": 1,
  "asset_id": "da1e9510-7c6d-4818-a982-c539bca831f4",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/da1e9510-7c6d-4818-a982-c539bca831f4/hiatal-type-3-sleeve-es-1086.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/da1e9510-7c6d-4818-a982-c539bca831f4/hiatal-type-3-sleeve-es-1086.webp",
  "original_filename": "hiatal-type-3-sleeve-es-1086.webp",
  "size": 91580,
  "content_type": "image/webp",
  "created_at": "2026-09-26T23:11:03Z"
}
